import { CustomTooltips } from '../components';

// Custom body template for foreign language column
export const foreignLanguageTemplate = (rowData) => {
  return (
    <CustomTooltips title="The Language the file has to be translated in" placement="bottom">
      <span>{rowData?.ForeignLanguage}</span>
    </CustomTooltips>
  );
};

// Custom body template for legal category column, shows the selected sub template below it
export const legalCategoryTemplate = (rowData) => {
  if (!rowData?.LegalCategory) return <div>--</div>;

  return (
    <div>
      <div>{rowData?.LegalCategory}</div>
      {rowData?.TemplateType && (
        <div style={{ fontSize: '13px', color: '#737791', lineHeight: '1.4' }}>{rowData?.TemplateType}</div>
      )}
    </div>
  );
};
